import {Subscription} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {Component, inject, OnDestroy, OnInit} from '@angular/core';

import {appRoutes} from "@numizmat/constants";
import {environment} from "@numizmat/environments";
import {MetaTagService} from "@numizmat/services/common";
import {RegistrationApiService} from "@numizmat/services/account";
import {ConfirmRegistrationRequest} from "@numizmat/services-models/account";

@Component({
  selector: 'nz-registration-confirm',
  standalone: true,
  imports: [],
  templateUrl: './registration-confirm.component.html',
  styleUrl: './registration-confirm.component.scss'
})
export class RegistrationConfirmComponent implements OnInit, OnDestroy {
  private router: Router = inject(Router);
  private metaTagService: MetaTagService = inject(MetaTagService);
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private registrationApiService: RegistrationApiService = inject(RegistrationApiService);

  private confirmRegistrationApiSubscription?: Subscription;

  public ngOnInit(): void {
    const registrationToken = this.activatedRoute.snapshot.queryParamMap.get('token');
    if (!!registrationToken) {
      this.confirmRegistration(registrationToken);
    } else {
      this.router.navigate([appRoutes.home]).then();
    }
    this.setMetaTags();
  }

  public ngOnDestroy(): void {
    this.confirmRegistrationApiSubscription?.unsubscribe();
  }

  private confirmRegistration(registrationToken: string): void {
    const request: ConfirmRegistrationRequest = {
      registrationToken: registrationToken,
    };
    this.confirmRegistrationApiSubscription = this.registrationApiService.confirmRegistration(request).subscribe({
      next: response => {
        if (response) {
          this.router.navigate([appRoutes.account, appRoutes.registrationSuccess]).then();
        } else {
          this.router.navigate([appRoutes.home]).then();
        }
      }
    });
  }

  private setMetaTags(): void {
    this.metaTagService.setCanonicalUrl(`${environment.applicationDomain}/${appRoutes.account}/${appRoutes.registrationConfirm}`);
    this.metaTagService.setTitle('Регистрация | Collectoria');
    this.metaTagService.setDescription('Регистрация | Collectoria');
  }
}
